import Key from "@/app/types/common/key";
import { translate } from "@/plugins/i18n";

export type DisplayTextSimple = Key;

export type DisplayText = Key | string | (() => string);

export function resolveDisplayText(
  displayText: DisplayText | undefined
): string {
  if (!displayText) {
    return "";
  }

  const resolvedFromFunc =
    displayText instanceof Function ? displayText() : displayText;

  return resolvedFromFunc instanceof Key
    ? translate(resolvedFromFunc)
    : resolvedFromFunc;
}
